import Profile from "./Profile"
import Email from "./Email"
import DL from "./DL"
import PhoneNumber from "./PhoneNumber"
import Voter from "./Voter"
import Passport from "./Passport"
import Aadhaar from './Aadhaar'


const Index = ({ selected }) => {
    const requestKey = selected?.requestKey
    if (requestKey === "altNumber1" || requestKey === "altNumber2") {
        return <PhoneNumber requestKey={requestKey} />
    }
    if (requestKey === "emailId") {
        return <Email />
    }
    if (requestKey === "profile" || requestKey === "profile2") {
        return <Profile requestKey={requestKey} />
    }
    if (requestKey === "dl" || requestKey === "dl2") {
        return <DL requestKey={requestKey} />
    }
    if (requestKey === "passport" || requestKey === "passport2") {
        return <Passport requestKey={requestKey} />
    }
    if (requestKey === "aadhaar" || requestKey === "aadhaar2") {
        return <Aadhaar requestKey={requestKey} />
    }
    return (
        <>
        </>
    )
}

export default Index